module.exports = __webpack_public_path__ + "static/media/leadersDefault.8bf9e969.svg";